import { useContext } from 'react'

import { ParametrizationConfigPurchaseContext } from '@provider/Parametrization/ConfigPurchaseParamProvider'

import { IConfigPurchaseParamProvider } from '@base/@types/providers/Parametrization/ConfigParamPurchase'
export default function useParametrizationConfigPurchase(): IConfigPurchaseParamProvider {
  const context = useContext(ParametrizationConfigPurchaseContext)

  return context
}
